<svg
  xmlns="http://www.w3.org/2000/svg"
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  data-testid="ai-loading-spinner"
>
  <circle
    cx="13"
    cy="13"
    r="12"
    stroke="#475263"
    stroke-width="2"
  />
  <circle
    id="fill-circle"
    cx="13"
    cy="13"
    r="12"
    stroke="#FEC742"
    stroke-width="2"
    stroke-dasharray="18.85 56.55"
  />
  <rect
    x="9"
    y="9"
    width="8"
    height="8"
    rx="1.6"
    fill="#FEC742"
  />
</svg>
